<template>
  <div
    class="c-two-column"
    :class="backgroundClass"
  >
    <div class="l-container">
      <h2
        v-if="title"
        :class="titleClass"
      >
        {{ title }}
      </h2>
      <h3
        v-if="subtitle"
        :class="subtitleClass"
        :style="{ fontFamily: subtitleFont }"
      >
        {{ subtitle }}
      </h3>
      <div class="l-grid l-grid--2-col">
        <template v-for="(card, $index) in cards">
          <component
            :is="card.contentType"
            :key="getKey(card, $index)"
            v-bind="card"
            :get-product-function="getProductFunction"
            :product="product"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import StickerCard from '../card/StickerCard'
import LandingPageCard from '../card/LandingPageCard.vue';
import DetailsCard from '../card/DetailsCard.vue'
import ContentCard from '../card/ContentCard.vue'
import uniqueId from 'lodash/uniqueId'

export default {
  components: {
    StickerCard,
    LandingPageCard,
    DetailsCard,
    ContentCard
  },
  props: {
    title: {
      type: String,
      default: null
    },
    titleTypography: {
      type: String,
      default: "t-heading-3"
    },
    titleAlignment: {
      type: String,
      default: "center"
    },
    titleMarginBottom: {
      type: String,
      default: "x-small"
    },
    titleColor: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: null
    },
    subtitleTypography: {
      type: String,
      default: "t-heading-3"
    },
    subtitleAlignment: {
      type: String,
      default: "center"
    },
    subtitleMarginBottom: {
      type: String,
      default: "x-small"
    },
    subtitleColor: {
      type: String,
      default: ""
    },
    subtitleFont: {
      type: String,
      default: "Poppins"
    },
    cards: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: null
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    getProductFunction: {
      type: Function,
      required: true
    },
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    backgroundClass() {
      return 'u-background-color-' + this.backgroundColor
    },
    titleClass() {
      let results = ['c-two-column__title']
      results.push(this.titleTypography);
      
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      if (this.titleAlignment) {
        results.push("u-text-align-" + this.titleAlignment)
      }
      if (this.titleMarginBottom) {
        results.push("u-margin-bottom-" + this.titleMarginBottom)
      }
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }
      return results;
    },
    subtitleClass() {
      let results = ['c-two-column__subtitle']
      results.push(this.subtitleTypography);
      
      if (this.subtitleColor) {
        results.push(this.subtitleTypography + '--' + this.subtitleColor);
      }
      if (this.subtitleAlignment) {
        results.push("u-text-align-" + this.subtitleAlignment)
      }
      if (this.subtitleMarginBottom) {
        results.push("u-margin-bottom-" + this.subtitleMarginBottom)
      }
      return results;
    },
  },
  methods: {
    getKey(card, index) {
      const id = this._uid
      return uniqueId(`${id}-${index}`)
    }
  }
};
</script>

<style lang="scss" scoped>
.c-two-column {
  padding: $section-padding;
  &_no-top-padding {
    padding-top: 0px !important;
  }
}
.c-two-column__title {
  padding: 0 rem(20px);
  padding-top: rem(58px);
}
.c-two-column__subtitle {
  max-width: rem(900px);
  margin-left: auto;
  margin-right: auto;
}
</style>
